import Flickity from 'flickity';

const init = () => {

  const addonCarousel = document.querySelector('.flickity-addon-carousel');
  window.addonCarousel = [];
  if (addonCarousel) {
      let params = addonCarousel.dataset.flickityInitParams;

      try {
          params = JSON.parse(params);
          var flkty = new Flickity(addonCarousel, params);
          window.addonCarousel.push(flkty);
      } catch(err) {
          console.warn(`Flickity slider: Can't initialize`, err);
      }
  }
  const disableButtonsAndDrag = (e) => {
    const intViewportWidth = window.innerWidth;
    window.addonCarousel.forEach(carousel => {
      let buttonsAndDragDisabled = (intViewportWidth > 991 && carousel.cells.length < 5)
        || (intViewportWidth >= 768 && carousel.cells.length < 4)
        || (intViewportWidth < 768 && carousel.cells.length < 2);
      if (buttonsAndDragDisabled) {
        carousel.select(0);
        carousel.isDraggable = false;
        $('.flickity-button').addClass('d-none');
      } else {
        carousel.isDraggable = true;
        $('.flickity-button').removeClass('d-none');
      }
    });
  }
  disableButtonsAndDrag();

  window.onresize = disableButtonsAndDrag;

}

export default init;